<template>
  <div>
    <pulse-loader
      v-if="loadingGraph"
      class="mt-5 text-center"
    ></pulse-loader>
    <GChart v-else type="AreaChart" :data="piChartData" :options="piChartOptions" />
  </div>
</template>

<script>
import { GChart } from "vue-google-charts";
import Vue from "vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  components: {
    GChart,
    PulseLoader
  },
  data: function () {
    return {
      chartOptions: {
        title: "Graph",
        curveType: "function",
        lineWidth: 2,
        intervals: { style: "line" },
        legend: "none",
        width: 900,
        height: 500,
      },
      piChartData: [["Time", "Index"]],
      piChartOptions: {
        chart: {
          title: "Sectoral PE Ratio",
          subtitle: "PE Ratio of all sectors",
        },
      },
      fetchedData: null,
      base_url:
        process.env.NODE_ENV === "production"
          ? "https://apidfl.bicm.ac.bd"
          : "http://localhost:8000",
      loadingGraph : 1
    };
  },
  methods: {
    loadGraphData() {
      Vue.axios
        .get(this.base_url + "/api/daily-indices-dsex?timestamp=" + new Date().getTime())
        .then((response) => {
          this.fetchedData = response.data.indices;
          this.pushDataToArray();
          this.loadingGraph = 0
        });
    },
    pushDataToArray() {
      for (var key in this.fetchedData) {
        var val = this.fetchedData[key];
        this.piChartData.push(val);
      }
      //    this.piChartData.push(this.fetchedData);
    },
  },
  mounted() {
    this.loadGraphData();
  },
};
</script>

<style></style>
